import { useState } from 'react';
import { t } from '@lingui/macro';

import Pencil from '@decisiv/iconix/lib/components/Pencil';

import Flex from '@decisiv/ui-components/lib/components/Flex';
import Button from '@decisiv/ui-components/lib/components/Button';

import UpdateDepotModal from '../../UpdateDepotModal';

import type { ManagedDepotsType } from '../..';

interface CellProps {
  rowData: ManagedDepotsType;
}

export default function ActionsCell({ rowData }: CellProps) {
  const [isModalOpen, setIsModalOpen] = useState(false);

  return (
    <>
      <Flex flex={1} justifyContent="center" alignContent="center">
        <Button
          size="small"
          kind="secondary"
          icon={Pencil}
          text={t`Edit`}
          onClick={() => setIsModalOpen(true)}
        />
      </Flex>
      <UpdateDepotModal
        visible={isModalOpen}
        handleClose={() => setIsModalOpen(false)}
        depot={rowData}
      />
    </>
  );
}
